export default __webpack_public_path__ + "static/media/fb.5af474a1.svg";